import { useEffect, useState } from 'react'
import cookies from 'js-cookie'
import { useMutation } from '@apollo/client'
import { useLoggedInUser } from '~/components/LoggedInUserContext'
import { STORE_REFERRAL_CODE } from '~/graphql/mutations/storeReferralCode'

const REFERRAL_COOKIE_NAME = 'pendingReferral'

const Referrals = () => {
  const { loggedInUser } = useLoggedInUser()
  const referralData = cookies.getJSON(REFERRAL_COOKIE_NAME)
  const [storeReferralCode] = useMutation(STORE_REFERRAL_CODE)
  const [referralStored, setReferralStored] = useState(false)

  useEffect(() => {
    if (referralStored) return
    if (!referralData || !loggedInUser) return

    const storeReferral = async () => {
      setReferralStored(true)

      try {
        cookies.remove('pendingReferral')
        await storeReferralCode({
          variables: {
            input: {
              sourceEventId: referralData.eventId,
              referrer: referralData.referral,
              code: referralData.referral_uid,
            },
          },
        })

        setReferralStored(false)
      } catch (error) {}
    }

    storeReferral()
  }, [referralData, loggedInUser, storeReferralCode, referralStored])

  return null
}

export default Referrals
